import React from "react";

function Footer() {
  return (
    <div className="bg-dark text-white text-center">
      <p className="px-4 pt-4 mb-0" style={{ fontSize: "0.75rem" }}>
        This is a simplified version of the{" "}
        <span>
          <a
            className="text-white"
            href="https://www.doh.gov.ph/sites/default/files/UPDATED%20DECISION%20TOOL.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            Decision Tool
          </a>
        </span>{" "}
        published by DOH-Philippines
      </p>
      <p className="px-4 pb-4 mb-0" style={{ fontSize: "0.75rem" }}>
        Developed by Dennis Macaspac | Logo by flaticon.com
      </p>
    </div>
  );
}

export default Footer;
